<template>
  <div>
    <span @click="operate('jiucuo', rowData)">处理</span>
  </div>
</template>
<script>
export default {
  name: 'jiucuo',
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    operate(type, rowData) {
      this.$emit('on-custom-comp', { type, rowData })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
  span {
    color: $blue;
    cursor: pointer;
  }
</style>
